@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="popup_main_div calculate-interest" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 cdkDragHandle matDialogTitle class="mat-dialog-header">
    <span>Calculate Interest</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="popup_body p-0">
      <div
        class="remove_left_right_padding one details-box"
        fxLayout="column"
        fxLayoutAlign="start"
        fxFlex="1 0 auto"
      >
        <div class="information">
          <mat-label>Matter</mat-label>
          {{ invoiceData?.MATTER }}
        </div>
        <div class="information">
          <mat-label>{{ ('' | productType) ? 'Client' : 'Solicitor' }}</mat-label>
          {{ invoiceData?.CLIENTNAME }}
        </div>
        <div class="information">
          <mat-label>Invoice</mat-label>
          {{ $safeNavigationMigration(invoiceData?.INVOICECODE) | invoiceNumber }}
        </div>
        <div class="information">
          <mat-label>Invoice Date</mat-label>
          {{ invoiceData?.INVOICEDATE }}
        </div>
        <div class="information">
          <mat-label>Due Date</mat-label>
          {{ invoiceData?.DUEDATE }}
        </div>
        <div class="information">
          <mat-label>Amount Outstanding</mat-label>
          {{ $safeNavigationMigration(invoiceData?.AMOUNTOUTSTANDINGINCGST) | toFixedAmount: true }}
        </div>
        <div class="information">
          <mat-label>Last Interest Date</mat-label>
          {{ LASTINTERESTDATE }}
        </div>
        <!-- <div class="information">
      <mat-label>Last Interest Date</mat-label> AAA
    </div> -->
      </div>
      <mat-divider horizontal></mat-divider>
      <div class="form-errors-model pt-24">
        <div class="example-container">
          <div align="center" class="pb-4">
            This will create an invoice that tracks the interest component of the selected invoice
          </div>
          <form class="flex w-full flex-col gap-4">
            <div class="w-full">
              <mat-form-field class="calculation-method-field" appearance="outline">
                <mat-label>Calculation Method</mat-label>
                <mat-select
                  [(ngModel)]="invoiceCalData.METHOD"
                  name="METHOD"
                  (selectionChange)="MethodChange($event.value)"
                >
                  <mat-option value="Compound">Compound</mat-option>
                  <mat-option value="Simple">Simple</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="w-full">
              <mat-form-field class="calculation-method-field" appearance="outline">
                <mat-label>Calculate Up to</mat-label>
                <input
                  matInput
                  [matDatepicker]="CalculateUpto"
                  [max]="tomorrow"
                  [(ngModel)]="invoiceCalData.DATE"
                  placeholder="Calculate Up to"
                  name="DATE"
                  (dateChange)="choosedDate('change', $event)"
                />
                <mat-datepicker-toggle matSuffix [for]="CalculateUpto"></mat-datepicker-toggle>
                <mat-datepicker #CalculateUpto></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="w-full">
              <mat-form-field class="calculation-method-field" appearance="outline">
                <mat-label>Interest Amount</mat-label>
                <input
                  matInput
                  currencyMask
                  [options]="{ align: 'left' }"
                  placeholder="Interest Amount"
                  name="INTERESTAMOUNT"
                  [(ngModel)]="invoiceCalData.INTERESTAMOUNT"
                />
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <div class="right_popup_btn">
      <button
        matButton="filled"
        class="mat-accent"
        mat-button
        (click)="SaveInvoice()"
        cdkFocusInitial
        [disabled]="isspiner"
      >
        @if (isspiner) {
          <mat-spinner
            style="
              zoom: 0.2;
              position: absolute;
              right: 0;
              left: 0;
              margin: auto;
              top: 0;
              bottom: 0;
            "
          ></mat-spinner>
        }
        Create Invoice
      </button>
      <button matButton="tonal" [mat-dialog-close]="true" color="primary">Cancel</button>
    </div>
  </mat-dialog-actions>
</div>
